export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14718.a6557c09.jpg";